import React, { ReactElement } from 'react';
import { useUserHasRole } from '@/lib/auth/useUserHasRoles';
import { Role } from '@/lib/auth/roles/role.enum';
import { Header } from 'elmo-elements';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import SettingsBaseRoutes, {
  SettingsParamTypes,
  TenantSettingsTabs,
} from '../SettingRoutes';

export interface TenantSettingsHeaderProps {
  headerTitle?: string;
  backButton?: {
    title: string;
    onClick: () => void;
  };
}
const SettingsHeader = ({
  headerTitle,
  backButton,
}: TenantSettingsHeaderProps): ReactElement => {
  const history = useHistory();
  const { tabSelected } = useParams<SettingsParamTypes>();
  const isElmoAdmin = useUserHasRole([Role.Admin, Role.Super, Role.Migration]);

  const commonTabLinks = [
    {
      label: 'Theme',
      onClick: () => {
        history.push(
          generatePath(SettingsBaseRoutes.path, {
            tabSelected: TenantSettingsTabs.Theme,
          }),
        );
      },
      active: tabSelected === TenantSettingsTabs.Theme,
    },
  ];

  const headerTabLinksForElmoAdmins = [
    {
      label: 'Publishing',
      onClick: () => {
        history.push(
          generatePath(SettingsBaseRoutes.path, {
            tabSelected: TenantSettingsTabs.Publishing,
          }),
        );
      },
      active: tabSelected === TenantSettingsTabs.Publishing,
    },
    {
      label: 'Categories',
      onClick: () => {
        history.push(
          generatePath(SettingsBaseRoutes.path, {
            tabSelected: TenantSettingsTabs.Categories,
          }),
        );
      },
      active: tabSelected === TenantSettingsTabs.Categories,
    },
    {
      label: 'Template',
      onClick: () => {
        history.push(
          generatePath(SettingsBaseRoutes.path, {
            tabSelected: TenantSettingsTabs.Template,
          }),
        );
      },
      active: tabSelected === TenantSettingsTabs.Template,
    },
  ];

  const headerTabLinks = isElmoAdmin
    ? [...headerTabLinksForElmoAdmins, ...commonTabLinks]
    : commonTabLinks;

  const title = headerTitle ?? 'Settings';

  return <Header title={title} tabs={headerTabLinks} backButton={backButton} />;
};
export default SettingsHeader;
